import { createContext } from 'react';

import { ReactComponent as HailopayLogo } from 'assets/icons/logo-hailopay-tagline-bottom.svg';
import { ReactComponent as HailopayHopLogo } from 'assets/icons/logo-hailopay-bounding.svg';
import { ReactComponent as FundLocalLogo } from 'assets/icons/logo-fundlocal.svg';
import { ReactComponent as JavelinLogo } from 'assets/icons/logo-javelin-nav-top.svg';
import PATHS from 'routes/paths';
import { isTest } from 'utils/environment';

/* brands */
export const HAILOPAY = 'hailopay';
export const FUNDLOCAL = 'fundlocal';
export const ADMIN = 'admin';
export const LOCAL = 'local';

export let brands = {
  [HAILOPAY]: {
    Logo: HailopayLogo,
    logoStyle: 'lg:w-full mx-auto transform scale-95',
    HopLogo: HailopayHopLogo,
    name: 'Hailopay',
    hasFundraisers: true,
    hasProducts: isTest ? true : false,
    hasOnboarding: true,
    dashboard: {
      name: 'Hailopay Dashboard',
      to: PATHS.home,
    },
    loginUrl: isTest
      ? `${window.location.origin}/login`
      : process.env.REACT_APP_HAILOPAY_LOGIN_URL,
    hasLogin: isTest ? true : false,
  },
  [FUNDLOCAL]: {
    Logo: FundLocalLogo,
    logoStyle: 'lg:w-8/12 lg:h-10 lg:mx-auto transform lg:scale-75 scale-90',
    HopLogo: FundLocalLogo,
    name: 'Fundlocal',
    hasFundraisers: true,
    hasProducts: false,
    hasOnboarding: true,
    dashboard: {
      name: 'Fundlocal Dashboard',
      to: PATHS.home,
    },
    loginUrl: process.env.REACT_APP_FUNDLOCAL_LOGIN_URL,
    hasLogin: false,
  },
  [ADMIN]: {
    Logo: JavelinLogo,
    logoStyle: 'lg:w-full lg:h-10 transform scale-75',
    HopLogo: () => <div />, // Admin doesn't have HOP&onboarding, this is just a caution
    name: 'Javelin',
    hasFundraisers: false,
    hasProducts: false,
    hasOnboarding: false,
    dashboard: {
      name: 'Dashboard',
      to: PATHS.home,
    },
    loginUrl: `${window.location.origin}/login`,
    hasLogin: true,
  },
};

brands[LOCAL] = brands[ADMIN];

export const DEFAULT_BRAND = brands.hailopay;

export const BrandContext = createContext(DEFAULT_BRAND);
